<template>
  <div class="wrapper">
    <div class="container">
      <div class="left">
        <div class="top">
          <img
            :src="
              avatarimg
                ? 'http://www.zhiyefangdong.com/uploads/avatarimg/' + avatarimg
                : '/static/img/avatarimg.png'
            "
            alt=""
          />
          <span class="name">{{ username }}</span>
        </div>
        <div class="people">
          <div
            v-for="(vo, k) in messageList"
            :key="k"
            :class="person == k + 1 ? 'person active' : 'person'"
            @click="toMessageDeatil(k + 1, userId, vo.uid)"
          >
            <div class="person-left">
              <img
                :src="
                  vo.avatarimg
                    ? 'http://www.zhiyefangdong.com/uploads/avatarimg/' +
                      vo.avatarimg
                    : '/static/img/avatarimg.png'
                "
                alt=""
              />
              <span v-if="vo.no_read_count > 0" id="msgNum" class="ii">{{
                vo.no_read_count
              }}</span>
            </div>
            <div class="person-right">
              <div class="userName">
                <div class="name">{{ vo.username }}</div>
                <div class="time">
                  {{ vo.send_time ? toDate(vo.send_time) : "" }}
                </div>
              </div>
              <div class="content">
                {{ vo.content }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="right">
        <div class="top">
          <span
            >To: <span class="name">{{ toUserName }}</span>
            <span class="online" v-if="toUserStatus == 1"
              >[ <span class="point" style="color: #3edb92;">●</span
              >{{ toUserStatus == 1 ? "在线" : "" }}]
            </span>
          </span>
        </div>
        <div class="chat_detail" ref="chatContainer">
          <div class="chat-item" v-for="(item, i) in messageDetail" :key="i">
            <!-- 房源信息 -->
            <div
              class="house"
              v-if="item.is_show_house === 1"
              @click="toHouseDeatil(item.fyxx_id)"
            >
              <div class="house_left">
                <img :src="item.imgurl ? item.imgurl : ''" alt="" />
              </div>
              <div class="house_right">
                <p>{{ item.fytitle }}</p>
                <p class="house_info">
                  <span>{{ item.rooms }}</span
                  ><span>{{ item.district }}</span>
                </p>
                <p>{{ item.price }}</p>
              </div>
            </div>
            <!-- 时间信息 -->
            <div v-if="item.is_show_time === 1" class="conversation-start">
              <span>{{ item.send_time_message }}</span>
            </div>
            <!-- 消息 -->
            <div
              v-if="item.message && item.message !== ''"
              :class="
                item.from_uid === userId
                  ? 'chat_item mright'
                  : 'chat_item mleft'
              "
              :data-touid="
                item.from_uid === userId ? item.to_uid : item.from_uid
              "
              :data-fyxx="item.fyxx_id"
            >
              <img
                class="avatarimg"
                :src="
                  'https://www.zhiyefangdong.com/uploads/avatarimg/' +
                    item.avatarimg
                "
                alt=""
              />
              <!-- 消息 -->
              <div
                v-if="item.type == 1"
                :class="item.from_uid === userId ? 'bubble me' : 'bubble you'"
              >
                <span style="">
                  {{ item.message }}
                </span>
              </div>
              <!-- 图片 -->
              <div
                v-if="item.type == 2"
                :class="item.from_uid === userId ? 'bubble me' : 'bubble you'"
              >
                <el-image
                  class="chatImg"
                  :src="item.message"
                  :preview-src-list="[item.message]"
                  @load="scrollToBottom"
                >
                  <div slot="error" class="image-slot">
                    图片加载失败…
                    <i class="el-icon-picture-outline"></i>
                  </div>
                </el-image>
              </div>
              <!-- 微信 -->
              <div
                v-if="item.type == 3"
                :class="item.from_uid === userId ? 'bubble me' : 'bubble you'"
              >
                <!-- <img class="chatImg" :src="item.message" alt="" /> -->
                <div class="link">
                  <p>微信号</p>
                  <span>{{ item.message }}</span>
                </div>
                <div
                  class="operate"
                  :data-clipboard-text="item.message"
                  @click="copyLink(item.type)"
                >
                  <i class="el-icon-document-copy"></i>
                  <span>点击复制</span>
                </div>
              </div>
              <!-- 手机号 -->
              <div
                v-if="item.type == 4"
                :class="item.from_uid === userId ? 'bubble me' : 'bubble you'"
              >
                <div class="link">
                  <p>手机号</p>
                  <span>{{ item.message }}</span>
                </div>
                <div
                  class="operate"
                  :data-clipboard-text="item.message"
                  @click="copyLink(item.type)"
                >
                  <i class="el-icon-document-copy"></i>
                  <span>点击复制</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="write">
          <el-input
            v-model="messageContent"
            type="text"
            class="content"
            @keyup.enter.native="sendMsg"
          ></el-input>
          <el-button @click="sendMsg" class="send">发送</el-button>
        </div> -->
        <div class="write">
          <div class="sendOthers">
            <el-tooltip
              class="item"
              effect="dark"
              content="发送图片"
              placement="top-start"
            >
              <el-upload
                name="Upload[file]"
                action="test"
                ref="upload"
                :multiple="true"
                :limit="10"
                :on-exceed="handleExceed"
                accept=".jpg, .jpeg, .png"
                :http-request="handleUpload"
                :auto-upload="true"
                :show-file-list="false"
              >
                <i class="el-icon-picture-outline"></i>
              </el-upload>
            </el-tooltip>
            <el-tooltip
              class="item"
              effect="dark"
              content="发送微信号"
              placement="top-start"
            >
              <i
                class="el-icon-chat-dot-square"
                @click="sendLinkMessage(3)"
              ></i>
            </el-tooltip>
            <el-tooltip
              class="item"
              effect="dark"
              content="发送手机号"
              placement="top-start"
            >
              <i class="el-icon-mobile" @click="sendLinkMessage(4)"></i>
            </el-tooltip>
          </div>
          <el-input
            resize="none"
            class="content"
            type="textarea"
            v-model="messageContent"
            @keydown.native="sendMsg($event)"
            placeholder="请输入咨询内容……"
          ></el-input>
          <el-button class="send" type="success" @click="sendMsg()"
            >发送</el-button
          >
        </div>
      </div>
      <!-- 自定义文件列表 -->
      <div class="file-list" v-if="files.length > 0">
        <div class="uploadimg">
          <div class="user">
            <p>发送给：</p>
            <div class="user-info">
              <img
                :src="
                  'https://www.zhiyefangdong.com/uploads/avatarimg/' +
                    toAvatarimg
                "
              />
              <span>{{ toUserName }}</span>
            </div>
          </div>
          <div class="file-item" v-for="(vo, index) in files" :key="index">
            <div class="file-name">{{ vo.name }}</div>
            <i
              class="el-icon-circle-close"
              @click="handleRemove(vo.name, files, index)"
            ></i>
            <!-- <el-button
              size="mini"
              type="danger"
              @click="handleRemove(vo.name, files, index)"
              >删除</el-button
            > -->
          </div>
          <div class="upload">
            <el-button @click="handleCancel">取消</el-button>
            <el-button type="primary" @click="sendImage">确定</el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import https from "../http.js";
import qs from "qs";
import { parseTime } from "../date.js";
import ClipboardJS from "clipboard";
export default {
  data() {
    return {
      person: 1,
      userId: "",
      userInfo: {},
      toUserId: "",
      toUserStatus: 0,
      avatarimg: "",
      username: "",
      toUserName: "",
      toAvatarimg: "",
      chatHouseId: "",
      messageList: [],
      messageDetail: [],
      messageContent: "",
      messageId: "",
      detailParams: {},
      file: [],
      files: [],
      isUploading: false,
      uploadImg: [],
    };
  },
  created() {
    var userId = this.$cookies.get("userid");
    if (!userId) {
      this.$alert("前往登录？", "登陆已过期，请重新登陆", {
        confirmButtonText: "确定",
        callback: (action) => {
          if (action == "cancel") {
            this.$router.push({ path: "/index" });
          } else {
            this.$router.push({ path: "/login" });
          }
        },
      });
      return false;
    }
    var houseId = this.$route.params.houseid;
    if (houseId != undefined) {
      this.detailParams = this.$route.params;
    }
    var usernamed = this.tool.getCookie("username");
    var avatarimgd = this.$cookies.get("avatarimg");
    if (usernamed !== null) {
      this.username = usernamed;
      this.userId = userId;
      this.avatarimg = avatarimgd;
    }
    this.getChatUserList();
  },
  async mounted() {
    window.addEventListener("onmessageWS", this.onSocketMessage);
  },
  methods: {
    //时间转化
    toDate(time) {
      return parseTime(time);
    },
    copyLink(type) {
      var clipboard = new ClipboardJS(".operate");
      clipboard.on("success", (e) => {
        var message =
          type == 3
            ? "微信号已复制，快去加他，别错过好房源哦！"
            : "手机号已复制，赶紧联系他，租房机会不等人！";
        this.$message.success(message);
        // 释放内存
        clipboard.destroy();
      });
    },
    async initWebSocket() {
      this.$websocket.connectSocket();
    },
    //监听socket消息
    onSocketMessage(res) {
      var onMessageData = res.detail.data;
      switch (onMessageData.type) {
        case "zhiyefangdong_init":
          var bind = '{"type":"bind","fromid":"' + this.userId + '"}';
          this.$websocket.sendWebsocket(bind);
          break;
        case "text":
          //如果是自己给自己发送就不需要
          if (onMessageData.toid == onMessageData.fromid) return;
          if (
            onMessageData.toid == this.userId &&
            onMessageData.fromid == this.toUserId
          ) {
            const messageDetail = this.messageDetail;
            const temp = {
              from_uid: onMessageData.fromid,
              to_uid: onMessageData.toid,
              avatarimg: this.toAvatarimg,
              message: onMessageData.content,
              send_time: onMessageData.date,
              type: onMessageData.message_type,
            };
            messageDetail.push(temp);
            this.messageDetail = messageDetail;

            //更新左侧用户列表数据
            this.messageList.forEach((e, index) => {
              if (e.uid == onMessageData.fromid) {
                let content = "";
                if (onMessageData.message_type == 1) {
                  content =
                    onMessageData.content.length > 20
                      ? onMessageData.content.slice(0, 20) + "……"
                      : onMessageData.content;
                } else if (onMessageData.message_type == 3) {
                  content = "[Wechat ID]";
                } else if (onMessageData.message_type == 4) {
                  content = "[Mobile]";
                }
                this.$set(this.messageList, index, {
                  ...e,
                  content: content, // 更新内容
                  no_read_count: parseInt(e.no_read_count) + 1,
                  send_date: onMessageData.date,
                });
              }
            });
            this.scrollToBottom();
          }
          break;
        case "say_img":
          //如果是自己给自己发送就不需要
          if (onMessageData.toid == onMessageData.fromid) return;
          if (
            onMessageData.toid == this.userId &&
            onMessageData.fromid == this.toUserId
          ) {
            // const messageDetail = this.messageDetail;
            const temp = {
              from_uid: onMessageData.fromid,
              to_uid: onMessageData.toid,
              avatarimg: this.toAvatarimg,
              message: onMessageData.img_name,
              send_time: onMessageData.date,
              type: onMessageData.message_type,
            };
            this.messageDetail.push(temp);
            // this.messageDetail = messageDetail;

            //更新左侧用户列表数据
            this.messageList.forEach((e, index) => {
              if (e.uid == onMessageData.fromid) {
                const content = "[Image]";
                this.$set(this.messageList, index, {
                  ...e,
                  content: content, // 更新内容
                  no_read_count: parseInt(e.no_read_count) + 1,
                  send_date: onMessageData.date,
                });
              }
            });
            this.scrollToBottom();
          }
          break;
        case "online":
          this.toUserStatus = onMessageData.status;
          if (onMessageData.status != 1) {
            //用户不在线，请求后端发送消息提醒给用户
            this.sendMessageSms(this.messageId);
          }
          break;
      }
    },
    //获取聊天列表
    getChatUserList() {
      https
        .fetchPost(
          "/chat/get-message-list",
          qs.stringify({ user_id: this.userId })
        )
        .then((res) => {
          this.messageList = res.data.data;
          if (this.messageList.length > 0) {
            if (this.detailParams.houseid != undefined) {
              this.toUserId = this.detailParams.to_uid;
              this.toUserName = this.detailParams.to_name;
              this.toAvatarimg = this.detailParams.to_avatarimg;
              this.chatHouseId = this.detailParams.houseid;
              //详情进来
              const result = this.messageList.find(
                (e) => e.uid == this.detailParams.to_uid
              );
              if (result) {
                //消息列表中有该用户
                this.getMessageDetail(result.id, true);
                let person = this.messageList.findIndex(
                  (item) => item.uid == this.detailParams.to_uid
                );
                this.person = parseInt(person + 1);
              } else {
                //消息列表中没有该用户
                this.messageList.unshift({
                  avatarimg: this.detailParams.to_avatarimg,
                  content: "",
                  fyxx_id: this.detailParams.houseid,
                  no_read_count: 0,
                  send_date: this.detailParams.send_date,
                  to_uid: this.detailParams.to_uid,
                  uid: this.detailParams.to_uid,
                  username: this.detailParams.to_name,
                });
                this.toUserName = this.detailParams.to_name;
                this.pushHouseMessageForDeatail();
              }
            } else {
              //列表进来
              this.toUserName = this.messageList[0].username;
              this.toAvatarimg = this.messageList[0].avatarimg;
              this.toUserId = this.messageList[0].uid;
              this.chatHouseId = this.messageList[0].fyxx_id;
              this.getMessageDetail(this.messageList[0].id);
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //获取聊天详情
    getMessageDetail(id, isNeedPushHouseMessage = false) {
      https
        .fetchPost("/chat/get-message-detail", qs.stringify({ id }))
        .then((res) => {
          this.messageDetail = res.data.data;
          if (this.detailParams) {
            //是当前聊天用户的房源才需要添加房源信息
            const uid =
              this.messageDetail[0].to_uid == this.userId
                ? this.messageDetail[0].from_uid
                : this.messageDetail[0].to_uid;
            if (isNeedPushHouseMessage && this.detailParams.to_uid == uid) {
              this.pushHouseMessageForDeatail();
            }
          }
          //滚动到底部
          this.getUserOnlineStatus(res.data.data[0]);
          this.scrollToBottom();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //获取当前用户在线状态
    getUserOnlineStatus(data) {
      const touid = data.to_uid == this.userId ? data.from_uid : data.to_uid;
      const message =
        '{"type":"online","fromid":"' +
        this.userId +
        '","toid":"' +
        touid +
        '"}';
      this.sendSocketMessage(message, 1);
    },
    //将聊天详情带进来的房源信息推送到聊天详情中
    pushHouseMessageForDeatail() {
      if (this.detailParams) {
        const temp = {
          fyxx_id: this.detailParams.houseid,
          fytitle: this.detailParams.fytitle,
          imgurl: this.detailParams.house_img,
          station: this.detailParams.station,
          district: this.detailParams.district,
          price: this.detailParams.price,
          to_uid: this.detailParams.to_uid,
          from_uid: this.userId,
          is_show_house: 1,
        };
        this.messageDetail.push(temp);
      }
    },
    // 更改未读为已读
    toMessageDeatil(person, from_uid, to_uid) {
      const user = this.messageList[person - 1];
      this.person = person;
      this.toUserName = user.username;
      this.toAvatarimg = user.avatarimg;
      this.toUserId = user.uid;
      this.chatHouseId = user.fyxx_id;
      this.messageList[person - 1].no_read_count = 0;
      //   this.messageList[person - 1].id
      if (user.id) {
        //有历史聊天消息
        https
          .fetchPost("/chat/change-no-read", qs.stringify({ from_uid, to_uid }))
          .then((res) => {
            this.$bus.$emit("changNoRead", res.data.data);
          });
        const isNeedPushHouseMessage =
          this.detailParams.houseid != undefined ? true : false;
        this.getMessageDetail(user.id);
      } else {
        this.messageDetail = [];
        this.pushHouseMessageForDeatail();
      }
      this.getUserOnlineStatus(user);
    },
    // 在消息更新后调用此方法
    scrollToBottom() {
      this.$nextTick(() => {
        const container = this.$refs.chatContainer;
        if (container) {
          container.scrollTo({
            top: container.scrollHeight,
            behavior: "smooth",
          });
        }
      });
    },
    //发送消息
    sendMsg(event = null) {
      if (event) {
        // 不是点击发送按钮
        if (event.keyCode == 13) {
          //如果按下回车 判断是换行还是发送消息
          if (event.shiftKey) {
            return;
          } else {
            event.preventDefault();
          }
        } else {
          //没有回车键则是输入内容
          return;
        }
      }
      if (!this.messageContent.trim()) return;
      this.saveMessage(this.messageContent, 1);
      const message = JSON.stringify({
        data: this.messageContent,
        type: "say",
        fromid: this.userId,
        toid: this.toUserId,
        message_type: 1,
      });
      const temp = this.sendSocketMessage(message, 1);
      this.messageDetail.push(temp);
      this.messageContent = "";
      this.scrollToBottom();
    },
    /**
     * 发送联系方式
     * @param message_type 1.文本2.图片3.微信4.手机号
     */
    async sendLinkMessage(message_type) {
      await this.getUserInfo(this.userId).then((res) => {
        if (message_type == 3) {
          var content = res.wxnum;
        } else {
          var content = res.phone;
        }
        this.saveMessage(content, message_type);
        if (content) {
          const message = JSON.stringify({
            data: content,
            type: "say",
            fromid: this.userId,
            toid: this.toUserId,
            message_type: message_type,
          });
          const temp = this.sendSocketMessage(message, message_type);
          this.messageDetail.push(temp);
          //   console.log(this.messageDetail, "this.messageDetail");

          this.scrollToBottom();
        }
      });
    },
    handleUpload(files) {
      //   console.log(files, "llll");
      if (!this.files.includes(files.file)) {
        this.files.push(files.file);
      }
      // 基于当前时间戳创建一个初始时间
      //   console.log(this.files);
    },
    handleCancel() {
      this.files = [];
    },
    handleRemove(fileName, fileList, index) {
      const removedFile = fileList.find((f) => f.name === fileName);
      if (removedFile) {
        this.$set(fileList, index, null);
        fileList.splice(index, 1);
      }
      this.files = fileList;
    },
    handleExceed(files) {
      this.$message.warning(
        `最多可以选择 9 个文件，您本次选择了 ${files.length} 个文件`
      );
    },
    async sendImage() {
      if (this.files.length == 0) {
        return false;
      }
      this.$refs.upload.submit(); // 提交文件
      let fd = new FormData();
      //   console.log(this.files, "ppp");
      // 在文件上传完成后，重置标志变量
      this.files.forEach(function(file) {
        fd.append("UploadForm[file][]", file, file.name); // 因为要上传多个文件，所以需要遍历一下才行
        //不要直接使用我们的文件数组进行上传，你会发现传给后台的是两个Object
      });

      const loading = this.$loading({
        lock: true,
        text: "上传中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });

      await https
        .fetchPost("/chat/chat-upload-imgs", fd, {
          headers: {
            "Content-type": "multipart/form-data",
          },
        })
        .then((res) => {
          this.uploadImg = res.data.img;
        })
        .catch((err) => {
          console.log(err);
        });
      let baseTimestamp = Math.floor(Date.now() / 1000);
      this.uploadImg.forEach((e, index) => {
        // console.log(index);
        const sendTime = baseTimestamp + index;
        this.saveMessage(e, 2, sendTime);
        const message = JSON.stringify({
          data: e,
          type: "say_img",
          fromid: this.userId,
          toid: this.toUserId,
          message_type: 2,
        });
        const temp = this.sendSocketMessage(message, 2);
        this.messageDetail.push(temp);
      });
      this.files = [];
      this.uploadImg = [];
      loading.close();
      this.scrollToBottom();
    },
    /**
     * 发送消息到socket
     * @param {*} message_type 1.文本2.图片3.微信4.手机号
     */
    sendSocketMessage(params, message_type) {
      this.$websocket.sendWebsocket(params);
      let timestamp = Date.parse(new Date());
      timestamp = Math.floor(timestamp / 1000); // 转换为秒
      params = JSON.parse(params);
      const temp = {
        message: params.data,
        send_time: timestamp,
        from_uid: this.userId,
        to_uid: this.toUserId,
        avatarimg: this.avatarimg,
        type: message_type,
      };

      //更新左侧用户列表数据
      this.messageList.forEach((e, index) => {
        if (e.uid == this.toUserId && params.data) {
          var content = "";
          switch (message_type) {
            case 1:
              content =
                params.data.length > 20
                  ? params.data.slice(0, 20) + "……"
                  : params.data;
              break;
            case 2:
              content = "[Image]";
              break;
            case 3:
              content = "[Wechat ID]";
              break;
            case 4:
              content = "[Mobile]";
              break;
          }
          var content = this.$set(this.messageList, index, {
            ...e,
            content: content, // 更新内容
            send_date: parseTime(new Date(), "{y}-{m}-{d} {h}:{i}:{s}"),
          });
        }
      });

      return temp;
    },
    /**
     * 保存消息
     * @param content
     * @param messageType 1.文本2.图片3.微信4.手机号
     */
    saveMessage(content, messageType, sendTime = null) {
      if (sendTime == null) {
        let timestamp = Date.parse(new Date());
        sendTime = Math.floor(timestamp / 1000); // 转换为秒
      }
      const params = {
        from_uid: this.userId,
        to_uid: this.toUserId,
        fyxx_id: this.chatHouseId,
        message: content,
        send_time: sendTime,
        type: messageType,
        type_message: 1,
      };
      https.fetchPost("/chat/add-message", qs.stringify(params)).then((res) => {
        this.messageId = res.data.data;
        this.getUserOnlineStatus(params);
        this.messageList.forEach((e, index) => {
          if (e.to_uid == this.toUserId) {
            this.$set(this.messageList, index, {
              ...e,
              content: content, // 更新内容
              send_date: sendTime,
              id: this.messageId,
            });
          }
        });
        // console.log(this.messageList, "messageList");
      });
    },
    /**
     * 发送短信提醒
     * @param messageId
     */
    sendMessageSms(mess) {
      if (!mess) return;
      https
        .fetchPost("/chat/send-message-sms", qs.stringify({ message_id: mess }))
        .then((res) => {
          return;
        });
    },
    //获取用户信息
    getUserInfo(userid) {
      return new Promise((resolve, reject) => {
        https
          .fetchGet("/wechat-center/get-user-info", { id: userid })
          .then((res) => {
            resolve(res.data.data);
          })
          .catch((err) => {
            reject(err);
          });
      });

      //   return new Promise((resolve, reject) => {
      //     const url = app.globalData.hostUrl + "/wechat-center/get-user-info";
      //     wx.request({
      //       url: url,
      //       method: "GET",
      //       data: {
      //         id: userid,
      //       },
      //       success: function(res) {
      //         resolve(res.data.data);
      //       },
      //       fail: function(res) {
      //         reject(res);
      //       },
      //     });
      //   });
    },

    toHouseDeatil(houseId) {
      let routeUrl = this.$router.resolve({
        path: "/HouseDetail",
        query: { houseid: houseId },
      });
      window.open(routeUrl.href, "_blank");
    },
  },
};
</script>

<style scoped>
*,
*:before,
*:after {
  box-sizing: border-box;
}

body {
  background-color: #f8f8f8;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-rendering: optimizeLegibility;
  font-family: "Source Sans Pro", sans-serif;
  font-weight: 400;
  /* background-image: url("/static/img/apartmentbac.jpg"); */
  background-size: cover;
  background-repeat: none;
}

.wrapper {
  position: relative;
  left: 50%;
  width: 100%;
  height: 800px;
  -webkit-transform: translate(-50%, 0);
  transform: translate(-50%, 0);
  background-image: url("../assets/images/zhiyeindex.jpg");
}

.container {
  position: relative;
  top: 50%;
  left: 50%;
  max-width: 900px;
  min-width: 600px;
  height: 75%;
  background-color: #fff;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}
.container .left {
  float: left;
  width: 37.6%;
  height: 100%;
  border: 1px solid #e6e6e6;
  background-color: #fff;
  overflow-y: auto;
  overflow-x: hidden;
}
.container .left .top {
  position: relative;
  width: 100%;
  height: 96px;
  padding: 29px;
  display: flex;
  align-items: center;
}
.container .left .top:after {
  position: absolute;
  bottom: 0;
  left: 50%;
  display: block;
  width: 80%;
  height: 1px;
  content: "";
  background-color: #e6e6e6;
  -webkit-transform: translate(-50%, 0);
  transform: translate(-50%, 0);
}
.container .left input {
  float: left;
  width: 188px;
  height: 42px;
  padding: 0 15px;
  border: 1px solid #e6e6e6;
  background-color: #eceff1;
  border-radius: 21px;
  font-family: "Source Sans Pro", sans-serif;
  font-weight: 400;
}

.container .left .people {
  margin-left: -1px;
  border-right: 1px solid #e6e6e6;
  border-left: 1px solid #e6e6e6;
  width: calc(100% + 2px);
}
.container .left .people .person {
  position: relative;
  width: 100%;
  /* padding: 12px 10% 16px; */
  padding: 15px;
  cursor: pointer;
  background-color: #fff;
  display: flex;
  font-size: 14px;
}

.container .left .people #msgNum {
  height: 18px;
  background: red;
  color: #fff;
  border-radius: 10px;
  position: absolute;
  text-align: center;
  line-height: 18px;
  left: 13%;
  top: 8px;
  font-size: 14px;
  font-weight: 500;
  padding: 0px 5px;
}
.container .left .people .person:after {
  position: absolute;
  bottom: 0;
  left: 50%;
  display: block;
  width: 80%;
  height: 1px;
  content: "";
  background-color: #e6e6e6;
  -webkit-transform: translate(-50%, 0);
  transform: translate(-50%, 0);
}
.container .left .people .person .person-left {
  width: 16%;
}
.container .left .people .person .person-right {
  width: 84%;
  padding-left: 10px;
}
.left .people .person .person-right .userName {
  display: flex;
  justify-content: space-between;
}
.person .person-right .userName .name {
  color: #000;
  font-weight: 600;
}
.person .person-right .userName .time {
  font-size: 13px;
}

.left .people .person .person-right .content {
  text-align: left;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.container .left .people .person img,
.container .left .top img {
  float: left;
  width: 40px;
  height: 40px;
  margin-right: 12px;
  border-radius: 10%;
}

.container .left .people .person.active,
.container .left .people .person:hover {
  margin-top: -1px;
  margin-left: -1px;
  /* padding-top: 13px; */
  border: 0;
  background-color: #00b0ff;
  width: calc(100% + 2px);
  /* padding-left: calc(10% + 1px); */
}
.container .left .people .person.active div,
.container .left .people .person:hover div {
  color: #fff;
  background: transparent;
}
.container .left .people .person.active:after,
.container .left .people .person:hover:after {
  display: none;
}
.container .right {
  position: relative;
  float: left;
  width: 62.4%;
  height: 100%;
}
.container .right .top {
  width: 100%;
  height: 47px;
  padding: 15px 29px;
  background-color: #eceff1;
}
.container .right .chat_detail .chat_item {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
}
.container .right .chat_detail .chat_item.mright {
  flex-direction: row-reverse;
}
/* 头像 */
.container .right .chat_detail .chat_item .avatarimg {
  width: 40px;
  height: 40px;
  border-radius: 10%;
}
.container .right .chat_detail .chat_item.mright .avatarimg {
  float: right;
  margin-left: 12px;
}
.container .right .chat_detail .chat_item.mleft .avatarimg {
  float: left;
  margin-right: 12px;
}
.container .right .top span {
  font-size: 15px;
  color: #999;
}
.container .right .top span .name {
  color: #1a1a1a;
  font-family: "Source Sans Pro", sans-serif;
  font-weight: 600;
}
.container .right .chat {
  display: none;
  padding: 0 35px 92px;
  border-width: 1px 1px 1px 0;
  border-style: solid;
  border-color: #e6e6e6;
  flex-direction: column;
}
.chat_detail {
  overflow-y: auto;
  height: 400px;
  padding: 0px 10px 10px;
  position: relative;
}
.container .right .chat.active-chat {
  overflow-x: hidden;
  display: flex;
  overflow-y: auto;
  height: 480px;
  position: absolute;
  width: 100%;
}
.container .right .chat.active-chat .bubble {
  transition-timing-function: cubic-bezier(0.4, -0.04, 1, 1);
}
.container .right .write {
  position: absolute;
  height: 150px;
  border-top: 1px solid #e6e6e6;
  width: 100%;
  bottom: 0px;
}
.container .right .write .sendOthers {
  height: 28%;
  font-size: 30px;
  display: flex;
  align-items: center;
}
.container .right .write .sendOthers i {
  width: 70px;
  color: #484848;
  cursor: pointer;
}
.container .right .write .content {
  position: relative;
  font-size: 14px;
  display: inline-block;
  width: 100%;
  height: 72%;
  border: none;
}

.container .right .write .send {
  position: absolute;
  right: 8px;
  bottom: 8px;
}

.container .right .bubble {
  font-size: 16px;
  position: relative;
  display: inline-block;
  clear: both;
  padding: 13px 14px;
  vertical-align: top;
  border-radius: 5px;
  max-width: 50%;
  /* max-height: 50%; */
  display: flex;
  align-items: center;
}

.container .right .bubble .link {
  padding-right: 10px;
}
.container .right .bubble .operate {
  padding-left: 10px;
  display: flex;
  flex-direction: column;
  cursor: pointer;
}
.container .right .bubble .operate i {
  font-size: 26px;
}
.container .right .bubble .operate span {
  font-size: 14px;
}
.container .right .bubble .chatImg {
  height: auto;
  width: auto;
  max-width: 100%;
  /* max-height: 300px; */
}
.container .right .bubble:before {
  position: absolute;
  top: 19px;
  display: block;
  width: 8px;
  height: 6px;
  content: "\00a0";
  -webkit-transform: rotate(29deg) skew(-35deg);
  transform: rotate(29deg) skew(-35deg);
}
.container .right .bubble.you {
  float: left;
  color: #fff;
  background-color: #00b0ff;
  align-self: flex-start;
  -webkit-animation-name: slideFromLeft;
  animation-name: slideFromLeft;
}

.container .right .bubble.you:before {
  left: -3px;
  background-color: #00b0ff;
}
.container .right .bubble.me {
  float: right;
  color: #1a1a1a;
  background-color: #eceff1;
  align-self: flex-end;
  -webkit-animation-name: slideFromRight;
  animation-name: slideFromRight;
}
.container .right .bubble.me .link {
  border-right: 1px solid #999999;
}
.container .right .bubble.you .link {
  border-right: 1px solid #fff;
}
.container .right .bubble.me:before {
  right: -3px;
  background-color: #eceff1;
}
.container .right .conversation-start {
  position: relative;
  width: 100%;
  margin-bottom: 27px;
  text-align: center;
}
.container .right .conversation-start span {
  font-size: 14px;
  display: inline-block;
  color: var(--grey);
}
.container .right .conversation-start span:before,
.container .right .conversation-start span:after {
  position: absolute;
  top: 10px;
  display: inline-block;
  width: 30%;
  height: 1px;
  content: "";
  background-color: #e6e6e6;
}
.container .right .conversation-start span:before {
  left: 0;
}
.container .right .conversation-start span:after {
  right: 0;
}
.container .file-list {
  position: absolute;
  width: 100%;
  height: 100%;
  padding: 10px;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.container .file-list .uploadimg {
  background: #fff;
  padding: 20px;
  border-radius: 10px;
}
.uploadimg .user p {
  text-align: left;
}
.uploadimg .user .user-info {
  display: flex;
  align-items: center;
  padding: 10px 0px;
  border-bottom: 0.5px solid #ddd;
}
.uploadimg .user .user-info img {
  width: 40px;
  height: 40px;
  border-radius: 5px;
  margin-right: 10px;
}

.container .file-list .uploadimg .upload {
  margin-top: 30px;
}

.container .file-list .file-item {
  display: flex;
  justify-content: space-between;
  padding: 10px 0px;
  align-items: center;
}
.container .file-list .uploadimg .file-item .file-name {
  margin-right: 10px;
}

.container .file-list .uploadimg .file-item i {
  font-size: 20px;
  background: #999;
  border-radius: 24px;
  color: #fff;
  cursor: pointer;
}
@keyframes slideFromLeft {
  0% {
    margin-left: -200px;
    opacity: 0;
  }
  100% {
    margin-left: 0;
    opacity: 1;
  }
}
@-webkit-keyframes slideFromLeft {
  0% {
    margin-left: -200px;
    opacity: 0;
  }
  100% {
    margin-left: 0;
    opacity: 1;
  }
}
@keyframes slideFromRight {
  0% {
    margin-right: -200px;
    opacity: 0;
  }
  100% {
    margin-right: 0;
    opacity: 1;
  }
}
@-webkit-keyframes slideFromRight {
  0% {
    margin-right: -200px;
    opacity: 0;
  }
  100% {
    margin-right: 0;
    opacity: 1;
  }
}
.right .chat_detail .house {
  color: #fff;
  width: 70%;
  margin: 20px auto;
  background: #000;
  height: 75px;
  border-radius: 5px;
  cursor: pointer;
}
.right .chat_detail .house .house_left {
  width: 25%;
  float: left;
  height: 75px;
}
.right .chat_detail .house .house_left img {
  width: 100%;
  height: 100%;
  border-radius: 5px;
}
.right .chat_detail .house .house_right {
  width: 75%;
  float: right;
  height: 75px;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  padding-left: 10px;
  font-size: 15px;
  text-align: left;
}
.right .chat_detail .house .house_right .house_info span {
  margin-right: 10px;
}
</style>
<style>
.container .right .write .content .el-input__inner {
  border: none;
}
.container .right .write .content .el-textarea__inner {
  height: 100%;
  border: none;
}
</style>
